module.exports = __webpack_public_path__ + "img/gh-101-j.asm.a3f49a88.jpg";